/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import * as React from 'react';

import { cssMap, cx, jsx } from '@compiled/react';

import UserAvatarCircleIcon from '@atlaskit/icon/core/migration/person-avatar--user-avatar-circle';
import { Box } from '@atlaskit/primitives/compiled';
import { N0, N20A, N90 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import { useImageState } from '../../hooks/use-image-state';

export type ProfilePictureProps = {
	src: string | undefined;
	testId?: string;
};

const styles = cssMap({
	imgContainer: {
		width: '64px',
		height: '64px',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'& svg, & img': {
			width: '64px',
			height: '64px',
		},
	},
	imgContainerSkeleton: {
		borderRadius: token('radius.full'),
		backgroundColor: token('color.background.neutral', N20A),
	},
	img: {
		display: 'block',
		borderRadius: token('radius.full'),
	},
});

export const ProfilePicture: React.ComponentType<ProfilePictureProps> = ({ testId, src }) => {
	const state = useImageState(src || '');

	const displayImage = src && state === 'loaded';
	const displayFallback = src && state === 'error';
	const displaySkeleton = !displayImage && !displayFallback;

	return (
		<Box
			testId={testId}
			xcss={cx(styles.imgContainer, displaySkeleton && styles.imgContainerSkeleton)}
		>
			{displayImage && (
				<img data-testid={testId && `${testId}--img`} src={src} css={styles.img} alt="" />
			)}
			{displayFallback && (
				<UserAvatarCircleIcon
					spacing="spacious"
					testId={testId && `${testId}--fallback`}
					label=""
					color={token('color.text.subtlest', N90)}
					LEGACY_secondaryColor={token('color.text.inverse', N0)}
				/>
			)}
		</Box>
	);
};
